import React, {Component} from 'react';
import {getNumericValue} from '../../../../../../common/util/fieldsValidation';
import './tooltip.scss';

class CustomTooltip extends Component {
  constructor(props) {
    super(props);
    this.getCompliance = this.getCompliance.bind(this);
  }
  
  getCompliance() {
    const {payload} = this.props;
    const salesObject = payload.find((item) => item.name === 'Ventas');
    const budgetObject = payload.find((item) => item.name === 'Presupuesto');
    
    if (!salesObject || !budgetObject) {
      return 0;
    }

    const sales = salesObject.value || 0;
    const budget = budgetObject.value || 1;
    const compliance = (sales / budget) * 100;

    return getNumericValue(compliance, 2);
  }

  renderValues(isActive, payload) {
    if (!isActive) {
      return null;
    }

    return payload.map((item, index) => {
      return (
        <div className='values' key={index} style={{'color': item.color}}>
          <strong>{item.name}:</strong> {'$'}{getNumericValue(item.value, 2)}
        </div>
      );
    });
  }

  renderComplience(compliance) {
    if (!compliance) {
      return null;
    }

    return (
      <div className='values'>
        <strong>Cumplimiento:</strong> {compliance}%
      </div>
    );
  }

  render() {
    const {label, active, payload} = this.props;
    const compliance = this.getCompliance();

    return (
      <div className='tooltip-content'>
        <div className='label'>{label}</div>
        {this.renderValues(active, payload)}
        {this.renderComplience(compliance)}
      </div>
    );
  }
}

export default CustomTooltip;
